export default {"src":"/_next/static/media/lightning-simple.8a8e6765.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};